























































import { mdiClose } from '@mdi/js'
import {
  defineComponent,
  Ref,
  ref,
  PropType,
  watch,
  onMounted,
} from '@vue/composition-api'
import AIcon from '../AIcon/AIcon.vue'

export type OverlayThemes = 'light' | 'dark'

export default defineComponent({
  components: { AIcon },
  props: {
    /**
     * Modal ein- bzw. ausblenden
     */
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    minimalPadding: {
      type: Boolean,
      default: false,
      required: false,
    },
    closeButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    closeButtonText: {
      type: Boolean,
      default: true,
      required: false,
    },
    containerShadow: {
      type: Boolean,
      default: true,
      required: false,
    },
    contentFullWidth: {
      type: Boolean,
      default: false,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
      required: false,
    },
    overlayTheme: {
      type: String as PropType<OverlayThemes>,
      default: 'dark',
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    message: {
      type: String,
      required: false,
    },
    maxWidth: {
      type: Number,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    absolute: {
      type: Boolean,
      default: false,
    },
    textCenter: {
      type: Boolean,
      default: false,
    },
    modalWrapperClasses: {
      type: String,
      required: false,
      default: '',
    },
    modalContainerClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props, { slots, emit }) {
    const contentSlotHasContent: Ref<boolean> = ref(
      slots.content ? true : false
    )
    function closeModal() {
      if (props.loading) return animateModalFn()
      emit('close')
    }
    const animateModal: Ref<boolean> = ref(false)
    function animateModalFn() {
      animateModal.value = true
      setTimeout(() => {
        animateModal.value = false
      }, 200)
    }
    const fadeIn: Ref<boolean> = ref(false)
    const showDelayed = ref(false)
    onMounted(() => {
      if (props.show) {
        showDelayed.value = true
        fadeIn.value = true
        setTimeout(() => (fadeIn.value = false), 200)
      }
    })
    watch(
      () => props.show,
      (newValue) => {
        if (newValue) {
          // show modal immediately
          showDelayed.value = true
          fadeIn.value = true
          // reset fadeIn after 300ms
          setTimeout(() => (fadeIn.value = false), 200)
        } else {
          // hide modal with animation
          fadeIn.value = false
          setTimeout(() => (showDelayed.value = false), 200)
        }
      }
    )
    return {
      mdiClose,
      contentSlotHasContent,
      closeModal,
      animateModal,
      animateModalFn,
      fadeIn,
      showDelayed,
    }
  },
})
